import { type ToolSet } from 'ai';

export const pickToolsByNamespace = (
  tools: ToolSet,
  namespaceByToolName: Map<string, string>,
  namespaces: string[],
): ToolSet =>
  Object.fromEntries(
    Object.entries(tools).filter(([name]) => {
      const namespace = namespaceByToolName.get(name);
      return namespace !== undefined && namespaces.includes(namespace);
    }),
  );
